module.exports = __webpack_public_path__ + "static/car8-80ae5981fa47d0158ec04b37f92d8f97.png";